import React from 'react';

import FormItemsInline from '../../../shared/items/static/formItemsInline'
import FormItem from '../../../shared/items/static/formItem'
import InputDate from '../../../shared/items/contols/inputDate'
import InputTime from '../../../shared/items/contols/inputTime'

const TimeMomentIntellegence = props => {
  const { onHandleChangeStore, valueStore } = props

  return (
    <React.Fragment>
      <FormItemsInline>
        <FormItem title="Дата">
          <InputDate
            name="momentDate"
            onHandleChangeStore={onHandleChangeStore.bind(this, "momentDate")}
            valueStore={valueStore}
            maxDate={new Date()}
          />
        </FormItem>

        <FormItem title="Время">
          <InputTime
            name="momentTime"
            onHandleChangeStore={onHandleChangeStore.bind(this, "momentTime")}
            valueStore={valueStore}
          />
        </FormItem>
      </FormItemsInline>
    </React.Fragment>
  )
}

export default React.memo(TimeMomentIntellegence)